.root {
  &[data-variant="default"] {
    --tabs-list-border-width: calc(0.1875rem * var(--mantine-scale)); /** 3px */
  }
}

.tab {
  &[data-variant="default"] {
    border-radius: 0;
    height: 46px;

    &[data-active] {
      border-color: light-dark(
        var(--mantine-color-primary-filled),
        var(--mantine-color-primary-light-color)
      );
      background-color: light-dark(
        var(--mantine-color-primary-light),
        var(--mantine-color-secondary-light)
      );
      color: light-dark(var(--mantine-color-primary-7), var(--mantine-color-primary-2));
      font-weight: 500;

      span,
      p {
        font-weight: 500;
      }
    }

    &:not([disabled]) {
      &:hover {
        background-color: light-dark(
          var(--mantine-color-primary-light-hover),
          var(--mantine-color-secondary-light-hover)
        );
        color: light-dark(
          var(--mantine-color-primary-filled),
          var(--mantine-color-primary-light-color)
        );
      }
    }
  }
}
